import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import AdOnService from '../../api/services/AdOnService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const AdOns = () => {  

    const [equipments, setEquipments] = useState([])
    const [isLoading, setisloading] = useState(true);
    useEffect(() => {
        getAdOns();
    }, []);

    const getAdOns = async () => {
        try {
          let adOns = await AdOnService.index().json();
         
          setEquipments(adOns.data);
          setisloading(false);
        } catch (error) {
          console.log(error);
        }
      };
      const deleteAdOns = async(id) => {
        let responseData = await AdOnService.destroy(id).json()
          swal({
            title: "Are you sure?",
            text:"Once deleted, you will not be able to recover this data!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
            }).then((willDelete) => {
            if (willDelete) {
                if (responseData.status === 200) {
                    getAdOns();
                } 
                swal("Your Camper Video has been deleted successfully!", {
                  icon: "success",
                });
            } 
            }).catch(() => {
                swal("Your Camper Video is safe!");
            });
      }
    return (
        <>
            <MainPagetitle mainTitle="AdOns" pageTitle={'AdOns'} parentTitle={'Home'} />  
            <div className="container-fluid">
				        <div className="row">
			    	        <div className="col-xl-12">
                        <div className="card">            
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">   
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">AdOns</h4>                                        
                                        <div>
                                            <Link to={`/admin/add_equipments/`} className="btn btn-primary btn-sm ms-1">+ Add Ad-Ons Equipments</Link> {" "}
                                        </div>
                                    </div>          
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr>   
                                                    <th>Title</th>
                                                    <th className="d-flex">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {equipments.map((item, index)=>(
                                                    <tr key={index}>   
                                                        <td>
                                                            <div className="products">
                                                                <h6>{item.title}</h6>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <Link
                                                                to={`/admin/edit_equipments/${item.id}`}
                                                                className="btn btn-primary shadow btn-xs sharp me-1"
                                                                >
                                                                <i className="fas fa-pencil-alt"></i>
                                                                </Link>
                                                                <Button className="btn btn-danger shadow btn-xs sharp" onClick={() => {deleteAdOns(item.id)}} 
                                                                >
                                                                <i className="fa fa-trash"></i>
                                                                </Button>
                                                            </div>
                                                        </td>
                                                       
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default AdOns;